import React from 'react';

interface IconItemsProps {
    iconClasses?: string;
}

const IconItems: React.FC<IconItemsProps> = ({ iconClasses }) => {
    return (
        <svg
            width="14"
            height="14"
            viewBox="0 0 14 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={`icon icon-items ${iconClasses ?? ''}`}
            aria-hidden="true"
        >
            <path
                d="M7.0013 1.16667L1.16797 4.08333L7.0013 7L12.8346 4.08333L7.0013 1.16667Z"
                stroke="currentColor"
                strokeWidth="1.16667"
            />
            <path
                d="M1.16797 9.91667L7.0013 12.8333L12.8346 9.91667"
                stroke="currentColor"
                strokeWidth="1.16667"
            />
            <path
                d="M1.16797 7L7.0013 9.91667L12.8346 7"
                stroke="currentColor"
                strokeWidth="1.16667"
            />
        </svg>
    );
};

export default IconItems;
